import type { Node, NodeProps } from '@xyflow/react';
import { DocumentTextIcon } from '@heroicons/react/24/outline';
import { Badge } from '../../../catalyst/badge';
import { nodeLabel } from '../graphModel';
import { chevronProps, type FlowNodeData } from '../useGraphLayout';
import { KIND_PALETTE } from '../kindPalette';
import { NodeShell } from './NodeShell';

const statusColor = (status: string) => (status === 'done' ? 'green' : status === 'error' ? 'red' : 'zinc');

export function DocumentNode({ data }: NodeProps<Node<FlowNodeData>>) {
  if (data.node.kind !== 'document') return null;
  const { title, category, extractionStatus } = data.node;
  return (
    <NodeShell
      icon={DocumentTextIcon}
      iconClassName="text-gray-500 dark:text-zinc-400"
      compactClassName={KIND_PALETTE.document.compact}
      label={nodeLabel(data.node)}
      selected={data.selected}
      focused={data.focused}
      {...chevronProps(data)}
      className="w-60"
    >
      <div className="truncate text-sm font-medium" title={title}>
        {title}
      </div>
      <div className="flex items-center gap-2">
        {category && <span className="truncate text-xs text-gray-500 dark:text-zinc-400">{category}</span>}
        {extractionStatus && <Badge color={statusColor(extractionStatus)}>{extractionStatus}</Badge>}
      </div>
    </NodeShell>
  );
}
